import { createSelector } from 'reselect';
import DespatchParticularsReceptacleDetailsColumns from '../../containers/DespatchParticularsReceptacleDetailsColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_PARTICULARS_RECEPTACLE_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.DESPATCH_PARTICULARS_RECEPTACLE_DETAILS.isLoading;

export const getData = ReportsDefinition.DESPATCH_PARTICULARS_RECEPTACLE_DETAILS.getDataFunction();

export const getColumns = createSelector(getData, DespatchParticularsReceptacleDetailsColumns);
